import {cleanItem, itemEditor, ui} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {summaryLines} from "../common/summary-lines-expo";

import {IntelligentMailBarcode} from "./intelligent-mail-barcode";

export const intelligentMailBarcodeModules = ({item, templateOptions}) => [
    {
        name: "imb1",
        load: ({method, enableAddressableShippingLogic2}, next) => IntelligentMailBarcode({
            templateOptions,
            item,
            method,
            enableAddressableShippingLogic2,
            next,
        }),
        expo: [cleanItem],
        requires: ["method", "enableAddressableShippingLogic2"],
    },
    {
        load: ({imb1, method, totalQuantity}, next) => imb1.next({
            method,
            totalQuantity,
            next,
        }),
        expo: [ui("imb"), itemEditor, summaryLines],
        requires: ["imb1", "method","totalQuantity"],
    },
];
